import React from 'react';
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { TimelineTaskCard } from './TimelineTaskCard';
import { useTimelineView } from './TimelineViewContext';
import { sortPlannerTasks } from './taskListOrder';

export const TimelineMonthTasksModal: React.FC<{ date: Date; onClose: () => void; onPrepareAction: () => void }> = ({
    date, onClose, onPrepareAction,
}) => {
    const { t, i18n } = useTranslation();
    const { getTasksForMonth, onCreateFlexibleTask } = useTimelineView();
    const tasks = sortPlannerTasks(getTasksForMonth(date));
    const label = date.toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' });
    return (
        <div className="timeline-day-modal-overlay" onClick={onClose} role="presentation">
            <section className="timeline-day-modal" role="dialog" aria-modal="true"
                aria-labelledby="timeline-month-modal-title" onClick={(event) => event.stopPropagation()}>
                <header>
                    <div>
                        <h2 id="timeline-month-modal-title">{label}</h2>
                        <span>{tasks.length}</span>
                    </div>
                    <button type="button" className="timeline-day-modal-close" onClick={onClose}
                        aria-label={t('dailyPlanner.cancel')}>
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                </header>
                <div className="timeline-day-modal-tasks">
                    {tasks.length ? tasks.map((task) => (
                        <TimelineTaskCard key={task.task.id} taskInfo={task} dateContext="month" onBeforeDelete={onPrepareAction}
                            onBeforeEdit={onPrepareAction} onBeforeOpen={onClose} />
                    )) : <p>{t('dailyPlanner.nothingScheduled')}</p>}
                </div>
                <button type="button" className="timeline-day-modal-add" onClick={() => {
                    onPrepareAction();
                    onClose();
                    onCreateFlexibleTask(date, 'month');
                }}>
                    <FontAwesomeIcon icon={faPlus} />
                    {t('dailyPlanner.addTask')}
                </button>
            </section>
        </div>
    );
};
